import React from 'react';
import { Smartphone, Briefcase, Network, Wifi } from 'lucide-react';
import { experienceVivo } from '../data/mock';
import { trackCtaClick } from '../utils/analytics';

const iconMap = {
  'smartphone': Smartphone,
  'briefcase': Briefcase,
  'network': Network,
  'wifi': Wifi
};

const ExperienceVivo = () => {
  const handleContactSolutions = () => {
    const subject = "Soluções digitais / arquitetura";
    const message = encodeURIComponent(`Olá! Gostaria de conversar sobre ${subject}.`);
    const whatsappUrl = `https://wa.me/5511984845464?text=${message}`;
    trackCtaClick({ cta: 'whatsapp', location: 'contact', url: whatsappUrl });
    window.open(whatsappUrl, '_blank');
  };

  return (
    <section id="experiencia-vivo" className="section-padding section-bg">
      <div className="container-custom">
        <h2 className="section-title">Experiência na Vivo</h2>
        <p className="section-subtitle">Produtos digitais, jornadas e arquitetura de soluções</p>
        
        <div className="experience-grid">
          {experienceVivo.map((item) => {
            const IconComponent = iconMap[item.icon] || iconMap["shield"];
            return (
              <div key={item.id} className="experience-card">
                <div className="experience-icon">
                  <IconComponent size={32} />
                </div>
                <h3 className="experience-title">{item.title}</h3>
                <p className="experience-description">{item.description}</p>
              </div>
            );
          })}
        </div>

        <div className="experience-cta">
          <button onClick={handleContactSolutions} className="btn-secondary">
            Conversar sobre soluções
          </button>
        </div>
      </div>
    </section>
  );
};

export default ExperienceVivo;
